var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"p-1 flex"},[_vm._l((_vm.params.value),function(item,index){return _c('div',{key:index},[(index === 0)?_c('p',[_vm._v(_vm._s(item))]):_c('p',[_vm._v(", "+_vm._s(item))])])}),_c('br')],2)}
var staticRenderFns = []

export { render, staticRenderFns }